// AUTH MODULE
export const SEND_OTP =
  process.env.REACT_APP_ACCOUNT_BASE_URL + "admin/auth/forgot";
export const LOGIN =
  process.env.REACT_APP_ACCOUNT_BASE_URL + "admin/auth/login";
export const RESET_PASSWORD =
  process.env.REACT_APP_ACCOUNT_BASE_URL + "admin/auth/update";
export const GET_USER = "admin/auth/admin-user";
export const GET_COUNTRIES = "country";
export const LOGGED_IN_USER = "admin/auth/user";

// STAFF MODULE
export const GET_ALL_STAFFS = "staff/staffs";
export const ADD_STAFF = "staff";
export const EDIT_STAFF = (id = "") => `staff?id=${id}`;
export const GET_STAFF = (userId) => `staff/${userId}`;
export const DELETE_STAFF = (userId = "") => `staff?userId=${userId}`;
export const RESEND_INVITE = "staff/resend";
export const DEACTIVATE_STAFF = (userId = "") =>
  `Staff/deactivate?userId=${userId}`;
export const REACTIVATE_STAFF = (userId = "") =>
  `Staff/reactivate?userId=${userId}`;

// SETTINGS MODULE
export const GET_ALL_DEPTS = "designation";
export const ADD_DEPT = "designation";
export const EDIT_DEPT = (id = "") => `designation/${id}/Update-designation`;
export const DELETE_DEPT = (id = "") => `designation?id=${id}`;

export const GET_ROLES = "admin/permissions/roles";
export const GET_ROLE = "admin/permissions/role";
export const ADD_ROLE = "admin/permissions/role";
export const EDIT_ROLE = "admin/permissions/role";
export const DELETE_ROLE = "admin/permissions/role";
export const ADD_PERMISSION = "admin/permissions/single";
export const ALL_PERMISSIONS = "admin/permissions?pageSize=100&pageNum=1";
export const GET_PERMISSION = "";
export const EDIT_PERMISSION = "";
export const DELETE_PERMISSION = (PermId = "") => "";
export const DEAC_ADMIN = (userId = "") =>
  `admin/auth/DeactivateAdminUser?userId=${userId}`;
export const DELETE_ADMIN = (userId) =>
  `admin/auth/DeleteAdminUser?userId=${userId}`;

// CLIENT MODULE
export const GET_ALL_CLIENTS = "client-management/clients";
export const GET_CLIENT_SERVICES = "ClientManagement/Get-all-services";
export const GET_ALL_LEADS = "client-management/leads";
export const GET_LEAD = "client-management/lead";
export const GET_LEAD_BY_RELATIONSHIP_OFFICER =
  "client-management/clients/officer";
export const ADD_LEAD = "client-management";
export const UPDATE_LEAD = (id = "") => `client-management?id=${id}`;
export const DELETE_CLIENT = (id = "") => `client-management?id=${id}`;
export const DELETE_SERVICE = (id = "") =>
  `client-management/delete-all-services?id=${id}`;
export const DEACTIVATE_CLIENT = (id = "") =>
  `client-management/deactivate?id=${id}`;
export const REACTIVATE_CLIENT = (id = "") =>
  `client-management/reactivate?id=${id}`;
export const CREATE_FLIGHT = "client-management/flight";
export const CREATE_VISA = "client-management/visa";
export const CREATE_ACCOMODATION = "client-management/accommodation";
export const CREATE_PROTOCOL = "client-management/protocol";
export const CREATE_PACKAGE = "client-management/package";

export const GET_FLIGHT = "client-management/flight";
export const GET_VISA = "client-management/visa";
export const GET_ACCOMODATION = "client-management/accommodation";
export const GET_PROTOCOL = "client-management/protocol";
export const GET_PACKAGE = "client-management/package";

export const GET_ALL_STRATEGY = "client-management/get-all-strategy-adopted";
export const GET_STRATEGY = "client-management/strategy-adopted";
export const CREATE_STRATEGY = "client-management/strategy-adopted";
export const UPDATE_STRATEGY = (id = "") =>
  `client-management/${id}/strategy-adopted`;
export const DELETE_STRATEGY = "client-management/strategy-adopted";
export const GET_ALL_PRODUCTS = "client-management/probable-products";
export const GET_PRODUCTS = "client-management/probable-product";
export const CREATE_PRODUCTS = "client-management/probable-product";
export const UPDATE_PRODUCTS = (id = "") =>
  `client-management/${id}/probable-product`;
export const DELETE_PRODUCTS = "client-management/probable-product";

// WORKlOG MOUDLE

export const CREATE_FLIGHT_OPERATION_LOG = "work-log/flight";
export const CREATE_VISA_OPERATION_LOG = "work-log/visa";
export const CREATE_ACCOMODATION_OPERATION_LOG = "work-log/accommodation";
export const CREATE_PROTOCOL_OPERATION_LOG = "work-log/protocol";
export const CREATE_PACKAGE_OPERATION_LOG = "work-log/package";
export const CREATE_DIGITAL_MARKETER_ACTIVITY = "work-log/digital";
export const CREATE_FINANCE_ACTIVITY = "work-log/finance";
export const CREATE_SALES_ACTIVITY = "work-log/sales";

export const GET_ALL_WORKLOGS = `work-log/operations`;
export const GET_OPERATION_ACTIVITIES_BY_RELATIONSHIP_OFFICER =
  "work-log/operation/officer";
export const GET_DIGITAL_MARKET_LOGS = `work-log/digitals`;
export const GET_DIGITAL_MARKET_LOG = (id) => `work-log/digital/${id}`;
export const GET_DIGITAL_ACTIVITIES_BY_RELATIONSHIP_OFFICER =
  "work-log/digital/officer";
export const GET_FINANCE_LOGS = `work-log/finances`;
export const GET_FINANCE_LOG = (id) => `work-log/finance/${id}`;
export const GET_FINANCE_ACTIVITIES_BY_RELATIONSHIP_OFFICER =
  "work-log/finance/officer";
export const GET_SALES_LOGS = `work-log/sales/by-status`;
export const GET_SALES_LOG = (id) => `work-log/sales/${id}`;
export const GET_SALES_ACTIVITIES_BY_RELATIONSHIP_OFFICER =
  "work-log/sales/officer";
export const GET_FLIGHT_LOG = "work-log/flight";
export const GET_VISA_LOG = `work-log/visa`;
export const GET_ACCOMODATION_LOG = "work-log/accommodation";
export const GET_PROTOCOL_LOG = "work-log/protocol";
export const GET_PACKAGE_LOG = "work-log/package";
export const DELETE_WORKLOG = (id = "") => `work-log/operations?id=${id}`;
export const DELETE_OPERATION_LOG = (id = "") =>
  `WorkLog/delete-operation-activity/${id}`;
export const DELETE_DIGITAL_MARKETER_LOG = (id = "") =>
  `work-log/digital?id=${id}`;
export const DELETE_FINANCE_LOG = (id = "") => `work-log/finance?id=${id}`;
export const DELETE_SALES_LOG = (id = "") => `work-log/sales?id=${id}`;
export const UPDATE_FLIGHT_LOG = (id = "") => `work-log/flight?id=${id}`;
export const UPDATE_VISA_LOG = (id = "") => `work-log/visa?id=${id}`;
export const UPDATE_ACCOMODATION_LOG = (id = "") =>
  `work-log/accommodation?id=${id}`;
export const UPDATE_PROTOCOL_LOG = (id = "") => `work-log/protocol?id=${id}`;
export const UPDATE_PACKAGE_LOG = (id = "") => `work-log/package?id=${id}`;
export const UPDATE_WORKLOG_STATUS = `work-log/operations-status`;
export const UPDATE_WORKLOG_OFFICER = `work-log/pass-on`;
export const UPDATE_DIGITAL_MARKETER_STATUS = (id = "") =>
  `work-log/digital?id=${id}`;
export const UPDATE_DIGITAL_MARKETER_OFFICER = `work-log/assign`;
export const UPDATE_FINANCE_STATUS = (id = "") => `work-log/finance?id=${id}`;
export const UPDATE_FINANCE_OFFICER = `work-log/assign`;
export const UPDATE_SALES_STATUS = (id = "") => `work-log/sales?id=${id}`;
export const UPDATE_SALES_OFFICER = `work-log/assign`;

// ACCOUNT MOUDULE

export const CREATE_ACCOUNT = "account-management";
export const GET_ALL_ACCOUNTS = `account-management`;
export const GET_ACCOUNT = (id = "") => `account-management/${id}`;
export const UPDATE_ACCOUNT = (id = "") => `account-management?id=${id}`;
export const DELETE_ACCOUNT = (id = "") => `account-management?id=${id}`;
export const GET_BANKS = `bank`;

// DASHBOARD MODULE

export const GET_ACTIVE_LEADS = "client-management/active-leads";
export const GET_TOTAL_CLIENTS = "client-management/total-clients-percentage";
export const GET_STAFF_DAILYPERFORMANCE = "work-log/tasks/completion";
export const GET_STAFF_WEEKLYPERFORMANCE = "work-log/tasks/weekly";
export const GET_STAFF_MONTHLYPERFORMANCE = "work-log/tasks/monthly";
export const GET_REVENUE_OVERVIEW = "";
export const GET_NOTIFICATIONS = "work-log/notifications";
export const GET_TOTAL_TRANSACTION_VOLUME_PERCENTAGE =
  "account-management/total-transaction-volume-percentage";
export const GET_WEEKLY_REVENUE = "account-management/weekly/revenue";
export const GET_MONTHLY_REVENUE = "account-management/monthly/revenue";
export const GET_YEARLY_REVENUE = "account-management/yearly/revenue";
export const GET_WEEKLY_CLIENTS = "client-management/weekly-leads-overview";
export const GET_MONTHLY_CLIENTS = "client-management/monthly-leads-overview";
export const GET_YEARLY_CLIENTS = "";
export const GET_WEEKLY_WORKLOG_COUNTS = "work-log/weekly";
export const GET_MONTHLY_WORKLOG_COUNTS = "work-log/monthly";
export const GET_YEARLY_TRANSACTIONS = "";
export const GET_TOTAL_WEEKLY_WORKLOG_STATUS = "work-log/weekly/by-status";
export const GET_TOTAL_WORKLOG = "work-log/monthly/percentage";

// HEADER

export const ALL_LOGGED_IN_USERS = "";
